module.exports = __webpack_public_path__ + "static/media/chevronTourLeft.7b07001e.svg";